import { useTranslation } from "react-i18next";
import { Ban, Check, Eye, Wallet } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { StatusPill } from "./StatusPill";
import { localPick } from "../../lib/localName";

// صف مكافأة واحد: الأزرار محكومة بالدور وبحالة المكافأة.
export const BonusRow = ({ row, index, isAdmin, canPay, onApprove, onPay, onCancel, onView }) => {
  const { t } = useTranslation();
  return (
    <tr className="border-b border-border/40" data-testid={`bonus-row-${row.bonus_id}`}>
      <td className="p-2 num text-xs text-muted-foreground">{index + 1}</td>
      <td className="p-2 num font-mono text-xs font-bold">{row.serial_number}</td>
      <td className="p-2 text-xs font-bold">{localPick(row, "employee_name")}</td>
      <td className="p-2 num font-mono text-xs font-bold">{row.amount} {row.currency}</td>
      <td className="p-2 max-w-[220px] truncate text-xs">{row.reason}</td>
      <td className="p-2 text-xs">{row.payment_source_name}</td>
      <td className="p-2"><StatusPill status={row.status} awaiting={row.awaiting_receipt}
                                      confirmation={row.confirmation_status} received={row.received} /></td>
      <td className="p-2 text-xs">
        {row.confirmation_status === "rejected_by_employee" && !row.received
          ? <span className="font-black text-destructive">{t("bonus.rejectedPill")}</span>
          : t(row.received ? "bonus.receivedYes" : "bonus.receivedNo")}
      </td>
      <td className="p-2 num font-mono text-xs" dir="ltr">{row.creation_date}</td>
      <td className="p-2">
        <div className="flex flex-wrap items-center gap-1">
          {isAdmin && row.status === "pending" ? (
            <NeuButton className="px-2 py-1 text-success" data-testid={`bonus-approve-btn-${row.bonus_id}`}
                       onClick={() => onApprove(row)} title={t("bonus.actions.approve")}>
              <Check className="h-3.5 w-3.5" />
            </NeuButton>
          ) : null}
          {canPay && row.status === "approved" && !row.paid ? (
            <NeuButton className="px-2 py-1 text-primary" data-testid={`bonus-pay-btn-${row.bonus_id}`}
                       onClick={() => onPay(row)} title={t("bonus.actions.pay")}>
              <Wallet className="h-3.5 w-3.5" />
            </NeuButton>
          ) : null}
          {isAdmin && !row.cancelled && !row.received ? (
            <NeuButton className="px-2 py-1 text-destructive" data-testid={`bonus-cancel-btn-${row.bonus_id}`}
                       onClick={() => onCancel(row)} title={t("bonus.actions.cancel")}>
              <Ban className="h-3.5 w-3.5" />
            </NeuButton>
          ) : null}
          <NeuButton className="px-2 py-1" data-testid={`bonus-view-btn-${row.bonus_id}`}
                     onClick={() => onView(row)} title={t("bonus.actions.view")}>
            <Eye className="h-3.5 w-3.5" />
          </NeuButton>
        </div>
      </td>
    </tr>
  );
};
